import { Component, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { EntityListAction, form_control, Permission, SaveReportFile } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { GridFilter, LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { HrmPayCurentYearMonthComponent } from "../../hrm-pay-curent-year-month/hrm-pay-curent-year-month.component";
import { HrmReportPrintKind } from "../../models/enums/round-kind";
import { HRNotificationHeader } from "../../models/hrnotification-header.model";

@Component({
  selector: "ngx-bill-pay-report",
  templateUrl: "./bill-pay-report.component.html",
  styleUrls: ["./bill-pay-report.component.scss"],
})
export class BillPayReportComponent extends BaseListComponent {
  loadingIndicator: boolean;
  inputEditorform: any;
  editingName: { name: string };
  actions: EntityListAction[];
  model: any;
  filterInfo: NameValue[] = [];
  @ViewChild(KGridComponent) grid: KGridComponent;
  constructor(private splashFormService: SplashFormService, private lookupservice: LookupService) {
    super();
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    this.apiName = "MonthlySalaryCalculationInformation/HRNotificationsHeader";
    this.areaName = "Payroll";
    this.label = "گزارش فیش حقوق";
    this.setColumns();
    this.setactions();
    if (this.accountService.authService.getHrmPayCurentYearMonth()) {
      if (
        this.accountService.authService.getHrmPayCurentYearMonth().CurentYear &&
        this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth
      ) {
        this.filterInfo.push({ Name: "IssueYear", Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentYear, Operator: "eq" });
        this.filterInfo.push({ Name: "IssueMonth", Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth, Operator: "eq" });
      }
    } else this.setHrmPayCurentYearMonth();
  }
  setColumns() {
    let group: any = {};
    this.model = {};
    this.model.IssueYear = this.accountService.authService.getHrmPayCurentYearMonth().CurentYear;
    this.model.IssueMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth;
    this.columns = [];
    this.columns.push(<form_control>{
      label: "سال",
      controlType: FormControlTypes.dropdown,
      modelName: "IssueYear",
      disabled: false,
      name: "IssueYear",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      columnNumber: 1,
      userClass: "select-shr",
      apiName: "FiscalYear/FiscalYear",
      valueMember: "Year",
      displayMember: "Year",
    });
    this.columns.push(<form_control>{
      label: "ماه",
      controlType: FormControlTypes.dropdown,
      modelName: "IssueMonth",
      disabled: false,
      name: "IssueMonth",
      order: 1,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      columnNumber: 2,
      userClass: "select-shr",
      apiName: "MonthsName",
      valueMember: "Id",
      displayMember: "Title",
    });
    this.columns.push(<form_control>{
      label: "نوع گزارش",
      controlType: FormControlTypes.dropdown,
      modelName: "HrmReportPrintKind",
      disabled: false,
      name: "HrmReportPrintKind",
      order: 2,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      columnNumber: 3,
      userClass: "select-sm",
      apiName: "Lookup",
      systemName: "HRM",
      category: "HrmReportPrintKind",
      valueMember: "Code",
      displayMember: "Title",
    });

    group["IssueYear"] = new UntypedFormControl(this.model.IssueYear, Validators.required);
    group["IssueMonth"] = new UntypedFormControl(this.model.IssueMonth, Validators.required);
    this.lookupservice
      .getLookupbyCode("HRM", "HrmReportPrintKind", HrmReportPrintKind.BillPayAll)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((rk) => {
        group["HrmReportPrintKind"] = new UntypedFormControl(rk.Code, Validators.required);
      });
    this.group = new UntypedFormGroup(group);
    this.model = this.getDataFromFormGroup(this.model);
  }
  onActionClick(
    action: EntityListAction,
    onRowSelected: HRNotificationHeader,
    onRowsSelected: HRNotificationHeader[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) {
    var filters: GridFilter[] = [];
    if (isAllSelected) {
      filters.push({ Filed: "IsAllSelected", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: isAllSelected, Logic: "and" });
    } else if (onRowsSelected && onRowsSelected.length > 0) {
      let PersonnelIds: number[] = [];
      onRowsSelected.forEach((x) => {
        PersonnelIds.push(x.HrmPersonnelId);
      });
      filters.push({ Filed: "PersonnelIds", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: PersonnelIds, Logic: "and" });
    } else if (onRowSelected) {
      let PersonnelIds: number[] = [];
      PersonnelIds.push(onRowSelected.HrmPersonnelId);
      filters.push({ Filed: "PersonnelIds", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: PersonnelIds, Logic: "and" });
    }

    ///  در اینجا باید سال و ماه محاسبه دریافت شود

    let IssueYear = this.group.controls["IssueYear"].value;
    let IssueMonth = this.group.controls["IssueMonth"].value;
    let IssueYearMonth = IssueYear * 12 + IssueMonth;
    filters.push({ Filed: "IssueYearMonth", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: IssueYearMonth, Logic: "and" });
    filters.push({ Filed: "IssueYear", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: IssueYear, Logic: "and" });
    filters.push({ Filed: "IssueMonth", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: IssueMonth, Logic: "and" });
    filters.push({
      Filed: "HrmReportPrintKind",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: this.group.controls["HrmReportPrintKind"].value,
      Logic: "and",
    });

    let FileName: string = "";
    if (this.group.controls["HrmReportPrintKind"].value === HrmReportPrintKind.BillPayWithOuteBackPay) FileName = "BillPayWithOuteBackPay";
    if (this.group.controls["HrmReportPrintKind"].value === HrmReportPrintKind.BillPayOnlyBackPay) FileName = "BillPayOnlyBackPay";
    if (this.group.controls["HrmReportPrintKind"].value === HrmReportPrintKind.BillPayAll) FileName = "BillPayAll";

    if (!filters || filters.length <= 0) {
      this.sts.showDialog("هیچ کارمندی انتخاب نشده است.", "");
    }
    this.splashFormService.openDialog("", "در حال تهیه فیش حقوقی");
    let saveReportFile: SaveReportFile = <SaveReportFile>{};
    saveReportFile.ReportTitle = this.label;
    saveReportFile.FileName = FileName;
    saveReportFile.SystemKindName = "HRM";
    saveReportFile.CategoryName = action.apiName.replace("/", "_");
    this.httpCommonService
      .create(action.apiName, filters)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          this.splashFormService.closeLoading();
          if (!x || x?.length <= 0) {
            this.sts.showDialog(`اطلاعات یافت نشد`, "خطا");
          } else {
            if (action.name === "Preview") this.grid.preview(saveReportFile, this.apiName, x as any[]);
            if (action.name === "Print") this.grid.print(saveReportFile, this.apiName, x as any[]);
            if (action.name === "Desine") this.grid.editReport(saveReportFile, this.apiName, x as any[]);
          }
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(`خطا در تهیه فیش حقوقی${Utilities.getHttpResponseMessage(error)}`, "خطا");
        }
      );
  }
  setHrmPayCurentYearMonth() {
    this.dialogService
      .open(
        HrmPayCurentYearMonthComponent,
        {
          areaName: this.areaName,
          label: this.label,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        this.ngOnInit();
      });
  }
  setactions() {
    this.actions = [
      {
        name: "Preview",
        disabled: false,
        displayName: "پیش نمایش",
        iconName: "icon-preview-f",
        apiName: "MonthlySalaryCalculationInformation/HrmBillPayRpt",
        areaName: "Payroll",
        permission: Permission.viewPermission,
      },
      {
        name: "Print",
        disabled: false,
        displayName: "چاپ ",
        iconName: "icon-print-f",
        apiName: "MonthlySalaryCalculationInformation/HrmBillPayRpt",
        areaName: "Payroll",
        permission: Permission.viewPermission,
      },
      {
        name: "Desine",
        disabled: false,
        displayName: "طراحی",
        iconName: "icon-design_services-F",
        apiName: "MonthlySalaryCalculationInformation/HrmBillPayRpt",
        areaName: "Payroll",
        requireSelectedrows: false,
        permission: Permission.viewPermission,
      },
    ];
  }
}
